import React from 'react';

import { Form } from 'antd';

import { Radio, RadioGroup } from '@element/index';
import { I18n } from '@utils/index';

import styles from './index.module.less';

export type ITYPE_MAP = {
  [key in 'FORTUNE' | 'GENERAL']: 'FORTUNE' | 'GENERAL'
}

export const TYPE_MAP: ITYPE_MAP = {
  /** 幸运空投 */
  FORTUNE: 'FORTUNE',
  /** 普通空投 */
  GENERAL: 'GENERAL'
}

const { Item } = Form;

interface SelectTypeFieldProps {
  /** 字段名 */
  name: string;
  className?: string;
}

export const SelectTypeField: React.FC<SelectTypeFieldProps> = (props) => {
  const { name, className } = props;
  return (
    <Item className={className} shouldUpdate={(prevValues, curValues) => {
      return prevValues[name] !== curValues[name]
    }}>
      {(form) => {
        return (
          <Item name={name} className={styles.item}>
            <div className={styles.container}>
              <span className={styles.label}>{I18n.t('zu75zNIQ')}</span>
              <RadioGroup name={name} className={styles.group} value={form.getFieldValue(name)} onChange={(e) => {
                const values = form.getFieldsValue();
                form.resetFields();
                form.setFieldsValue({
                  ...values,
                  [name]: e.target.value
                })
              }}>
                <Radio
                  data-buried="fortune-airdrop"
                  value={TYPE_MAP.FORTUNE}
                  className={styles.radio}
                  isChecked>{I18n.t('tnZ3Gs8U')}</Radio>
                <Radio
                  data-buried="general-airdrop"
                  value={TYPE_MAP.GENERAL}
                  className={styles.radio}
                  isChecked>{I18n.t('UQwkViPO')}</Radio>
              </RadioGroup>
            </div>
          </Item>
        );
      }}
    </Item>
  );
}
